import { useState } from "react";
import Layout from "../components/Layout";
import { useLang } from "../utils/LangContext";

function Contact() {
  const { t } = useLang();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let newErrors = {};
    if (!form.name) newErrors.name = t('Name is required');
    if (!form.email) newErrors.email = t('Email is required');
    if (!form.message) newErrors.message = t('Message is required');
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      alert("Form submitted successfully!");
    }
  };

  return (
    <Layout>
      <div className="text-center">
        <h1 className="fw-bold">{t('Contact Us')}</h1>
        <form className="mt-4" onSubmit={handleSubmit}>
          <div className="mb-3">
            <input type="text" name="name" className="form-control" placeholder={t('Name')} value={form.name} onChange={handleChange} />
            {errors.name && <div className="text-danger">{errors.name}</div>}
          </div>
          <div className="mb-3">
            <input type="email" name="email" className="form-control" placeholder={t('Email')} value={form.email} onChange={handleChange} />
            {errors.email && <div className="text-danger">{errors.email}</div>}
          </div>
          <div className="mb-3">
            <textarea name="message" className="form-control" placeholder={t('Message')} value={form.message} onChange={handleChange} />
            {errors.message && <div className="text-danger">{errors.message}</div>}
          </div>
          <button type="submit" className="btn btn-primary">{t('Send')}</button>
        </form>
      </div>
    </Layout>
  );
}

export default Contact;
